import { http } from "@/lib/http";
export function fetchRedemptionProducts() {
  return http.get("/api/redemptions/get_all").then((res) => res.data);
}
export function fetchRedemptionProduct(id) {
  return http.get(`/api/redemptions/get/${id}`).then((res) => res.data);
}
export function addRedemptionProduct(payload) {
  return http.post("/api/redemptions/add", payload).then((res) => res.data);
}
export function updateRedemptionProduct(id, payload) {
  return http
    .post("/api/redemptions/update", { ...payload, docId: id })
    .then((res) => res.data);
}
export function deleteRedemptionProduct(id) {
  return http.delete(`/api/redemptions/delete/${id}`).then((res) => res.data);
}
